import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, of } from 'rxjs';

import { environment } from '@env/environment';
import { LongRunningTaskData, WebApiResponseBase } from '@shared/classes/general';
import { Utilities } from '@shared/utils/utilities';

@Injectable({
  providedIn: 'root'
})
export class WebApiService {
  constructor(private http: HttpClient) { }

  /**
   * Generic method to interact with Backend WebAPI
   * @param httpMethod {string}
   * @param urlRoute {string}
   * @param payload {object}
   * @param taskData {LongRunningTaskData}
   */
  request = <T>(httpMethod: string, urlRoute: string, payload: object = null, taskData: LongRunningTaskData = null) => {
    var _url = `${environment.api.uri}${environment.api.backendVersion}${urlRoute}`,
      method = httpMethod,
      _headers: any = taskData ? { "x-dmp-task-id": taskData.taskId } : {};
    return this.http.request<T>(method, _url, { body: payload, headers: _headers }).pipe(catchError(this.handleError));
  }

  requestRawData = (httpMethod: string, callBackend: boolean = true, urlRoute: string, payload: object = null, taskData: LongRunningTaskData, responseType: HttpResponseType) => {
    var _url = `${environment.api.uri}${environment.api.backendVersion}${urlRoute}`,
      method = httpMethod,
      _headers = taskData ? { "x-dmp-task-id": taskData.taskId } : {};
    return this.http.request(method, (callBackend ? _url : urlRoute), { body: payload, headers: _headers, responseType: responseType })
      .pipe(catchError(this.handleError));
  }

  uploadFile = (url: string, file: File) => {
    return this.http.put(url, file).pipe(catchError(this.handleError));
  }

  private handleError = (error: HttpErrorResponse) => {
    var errorResponse = error.error as WebApiResponseBase;
    if (!errorResponse || Utilities.isEmptyString(errorResponse.friendlyMessage_Translation_Id)) {
      errorResponse = { friendlyMessage_Translation_Id: "ml_151107" } as WebApiResponseBase;
    }

    errorResponse.httpResponseStatus = error.status;
    return of(errorResponse);
  }
}

export type HttpResponseType = "arraybuffer" | "blob" | "text" | "json";
